import { render, staticRenderFns } from "./ImpressumView.vue?vue&type=template&id=733ae043&scoped=true&"
var script = {}
import style0 from "./ImpressumView.vue?vue&type=style&index=0&id=733ae043&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733ae043",
  null
  
)

export default component.exports